import React from 'react';
import {NewsItemDataStructure} from "./news-item-data.structure";
import {BaseProps} from "../../../infrastructure/models/props/base-props";


export class NewsItemDataStructureWrapperProps extends BaseProps {

}

export const NewsItemDataStructureWrapper = ({
                                               controller,
                                               newsItem,
                                               children
                                             }: NewsItemDataStructureWrapperProps) => {
  const {state: {shouldRenderMicroData}} = controller;
  return shouldRenderMicroData ?
    <NewsItemDataStructure itemMetaData={newsItem.metaDataModel}>{children}</NewsItemDataStructure> : <>{children}</>
}
